import { createNamespacedHelpers } from "vuex";
import { PlusSquareIcon, EditIcon, Trash2Icon } from "vue-feather-icons";
import NewActionModal from "@/components/newActionModal/newActionModal.vue";
import BooleanModal from "@/components/booleanModal/booleanModal.vue";
import { createTooltipContent } from "@/utils";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	props: { cardData: Object },

	components: {
		PlusSquareIcon,
		EditIcon,
		Trash2Icon,
		NewActionModal,
		BooleanModal,
	},

	data() {
		return {
			labelId: this.cardData.label_id,
			actions: null,
			dows: [
				this.$t("days.monday"),
				this.$t("days.tuesday"),
				this.$t("days.wednesday"),
				this.$t("days.thursday"),
				this.$t("days.friday"),
				this.$t("days.saturday"),
				this.$t("days.sunday"),
			],
			sources: [
				"N/A",
				"N/A",
				"N/A",
				this.$t("toggle_legend.production"),
				this.$t("toggle_legend.preparation"),
				this.$t("toggle_legend.plate"),
			],
			inNewAction: false,
			date_: undefined,
			description_: "",
			saveActionFn: undefined,
			isDelActionModalShown: false,
			actionIdToDelete: null,
		};
	},

	methods: {
		openNewAction,
		openEditAction,
		addNewAction,
		loadActions,
		deleteAction,
		editAction,
		createTooltipContent,
		showDeleteActionModal,
	},

	computed: { ...brandingGetters(["colors"]) },

	mounted() {
		this.loadActions();
	},
};

function openNewAction() {
	this.date_ = undefined;
	this.description_ = "";
	this.type_ = "";
	this.saveActionFn = this.addNewAction;
	this.inNewAction = true;
}

function showDeleteActionModal(actionId) {
	this.actionIdToDelete = actionId;
	this.isDelActionModalShown = true;
}

function openEditAction(actionId, date, description, type) {
	this.date_ = date;
	this.description_ = description;
	this.type_ = type;
	this.saveActionFn = (dt, dsc, t) => this.editAction(actionId, dt, dsc, t);
	this.inNewAction = true;
}

async function addNewAction(date, description, type) {
	try {
		await this.$api.setTrackedItemAction(this.labelId, date, description, type);
		this.inNewAction = false;
		this.loadActions();
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}

async function loadActions() {
	try {
		const { data } = await this.$api.getTrackedItemActions(this.labelId);
		this.actions = data;
	} catch (error) {
		this.actions = [];
	}
}

async function deleteAction(actionId) {
	await this.$api.deleteTrackedItemAction(this.labelId, actionId);
	this.isDelActionModalShown = false; // Hide modal after deletion confirmed
	this.loadActions();
}

async function editAction(actionId, date, description, type) {
	try {
		await this.$api.updateTrackedItemAction(this.labelId, actionId, date, description, type);
		this.inNewAction = false;
		this.loadActions();
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}
